import { Button, Flex } from "antd";
import useWepapp from "../hook/useWepapp";

const { Outlet } = require("react-router-dom")

const VerifyComponent = ({
    p5 = ""
}) => {
    const { goToMenu = () => { } } = useWepapp()
    return (
        <Flex>
            <h1>{p5}</h1>
            <Button onClick={() => goToMenu("consent")}>lets see consent letter</Button>
        </Flex>
    )
}
export default VerifyComponent;